export default class Scroll {
    constructor(sheet) {
        this.sheet = sheet;
        this.main = sheet.main;
        this.config = sheet.config;
    }

    getPosition() {
        return this.sheet.$sheet[0].scrollTop;
    }

    getHeight() {
        return this.sheet.$sheet[0].scrollHeight;
    }

    toPosition(scrollTo) {
        scrollTo = Math.round(scrollTo);

        this.sheet.$sheet[0].scrollTo({
            top: scrollTo,
            behavior: 'instant'
        });
    }

    toDate(month, year) {
        const { showDateSelector } = this.config.get();

        // Находим элемент с искомым месяцем и скроллим
        const $year = this.sheet.$sheet.find(`.f-calendar__sheet--year[year=${ year }]`);
        const $month = $year.find(`.f-calendar__sheet--month[month=${ month }]`);

        if (!$month.length) {
            console.warn(`scroll.toDate(month: ${ month }, year: ${ year }) - not found`);
            return;
        }

        // Измеряем куда будем скроллить
        let scrollTo = $year[0].offsetTop + $month[0].offsetTop; // Если у года pos:rel;, то считаем по такой формуле

        if (showDateSelector) {
            const $header = $month.find('.f-calendar__sheet--month-header');

            scrollTo += $header[0].offsetHeight;
        }

        // Скроллим до выбранного месяца
        this.toPosition(scrollTo);
    }
}
